export enum SearchOption {
    TopDirectoryOnly = 0,
    AllDirectories = 1
}
